<template>
  <v-footer class="bg-surface-variant text-on-surface-variant pa-4">
    <v-row no-gutters justify="center">
      <v-col cols="auto" class="text-body-2">
        &copy; {{ new Date().getFullYear() }} Arvee Solutions, Inc. All rights
        reserved.
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" class="mt-1">
      <v-col cols="auto" class="text-body-2">
        <NuxtLink to="/browse" class="text-on-surface-variant">
          Browse
        </NuxtLink>
        <span class="mx-2">|</span>
        <NuxtLink to="/terms" class="text-on-surface-variant">
          Terms of Service
        </NuxtLink>
        <span class="mx-2">|</span>
        <NuxtLink to="/privacy" class="text-on-surface-variant">
          Privacy Policy
        </NuxtLink>
        <span class="mx-2">|</span>
        <NuxtLink to="/do-not-sell" class="text-on-surface-variant">
          Your Privacy Choices
        </NuxtLink>
        <span class="mx-2">|</span>
        <NuxtLink to="/refund-policy" class="text-on-surface-variant">
          Refund Policy
        </NuxtLink>
        <span class="mx-2">|</span>
        <NuxtLink to="/help" class="text-on-surface-variant"> Help </NuxtLink>
        <span class="mx-2">|</span>
        <a href="mailto:support@arvee.io" class="text-on-surface-variant">
          Contact
        </a>
      </v-col>
    </v-row>
  </v-footer>
</template>
